// Action types for fetching orders
export const FETCH_PRODUCTS_COUNT_REQUEST = 'FETCH_PRODUCTS_COUNT_REQUEST';
export const FETCH_PRODUCTS_COUNT_SUCCESS = 'FETCH_PRODUCTS_COUNT_SUCCESS';
export const FETCH_PRODUCTS_COUNT_FAILURE = 'FETCH_PRODUCTS_COUNT_FAILURE';
// Fetch data actions
export const fetchProductsCountRequest = (payload) => ({
    type: FETCH_PRODUCTS_COUNT_REQUEST,
    payload,
});
export const fetchProductsCountSuccess = (payload) => ({
    type: FETCH_PRODUCTS_COUNT_SUCCESS,
    payload,
});
export const fetchProductsCountFailure = (error) => ({
    type: FETCH_PRODUCTS_COUNT_FAILURE,
    payload: error,
});
